module.exports = __webpack_public_path__ + "files/SPIADI2025 - Rapport annuel d'activité.dcf22646d851d03724fccd7042d2dd3e.pdf";